import H4Component from 'primitives/Typography/Headings/H4';
import styled from '@emotion/styled';

const H4 = styled(H4Component)({
  position: 'relative',
});

export default H4;
